import { createSelector } from "reselect";

import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";

import { selectContactsSearchProfilesStateSlice } from "../../advanced-search/store/selectors";

const select = createStatePropertySelector(selectContactsSearchProfilesStateSlice);

/** Fetch all Profiles */
export const selectProfilesResult = select("profilesResult");
export const selectCreatedProfile = select("createdProfile");
export const selectProfilesAreBeingFetched = select("areProfilesFetching");
/** Profile create */
export const selectProfileIsCreating = select("isProfileCreating");
/** Profile update */
export const selectProfileIsUpdating = select("isProfileUpdating");
/** Profile delete */
export const selectProfileIsDeleting = select("isProfileDeleting");
/** Profile exclude */
export const selectProfileIsExcluding = select("isProfileExcluding");
/** Selects an array of profiles */
export const selectProfilesList = createSelector(selectProfilesResult, (result) => result.profiles);
